import { styled } from '@mui/material';
import { StyledDiscoveryTiles } from '../DiscoverySection/styled';

export const StyledGridContainer = styled(StyledDiscoveryTiles)(
  ({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(8, 35vw)',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
  })
);
